<template>
    <div :class="['text-container', resolvedTextAlign]">
        <AnimationWrapper is-final-section>
            <template #animationContent>
                <div
                    v-if="textIsNotEmpty(section.title.text)"
                    class="text"
                    :class="section.title.style?.textStyle ? section.title.style.textStyle : defaultTitleStyle()"
                    :style="sectionStyle()"
                    v-html="fixText('title')"
                >
                </div>
                <div
                    v-if="section.subtitle && textIsNotEmpty(section.subtitle?.text)"
                    class="text"
                    :class="section.subtitle.style?.textStyle ? section.subtitle.style.textStyle : defaultSubtitleStyle()"
                    :style="sectionStyle()"
                    v-html="fixText('subtitle')"
                >
                </div>
            </template>
        </AnimationWrapper>
    </div>
</template>
<script>
import AnimationWrapper from "@/scripts/common/components/AnimationWrapper.vue";
import {SectionTypesEnum} from "@/scripts/common/enums.js";

export default {
    name: "Title",
    components: {AnimationWrapper},
    props: ['section'],
    computed: {
        resolvedTextAlign() {
            if (this.section?.title?.style?.textAlign) {
                return this.section.title.style.textAlign;
            }

            if (this.section?.type === SectionTypesEnum.MAIN_HEADER || this.section?.type === SectionTypesEnum.HEADER) {
                return 'center';
            }

            return null;
        }
    },
    methods: {
        fixText(data) {
            return this.section[data].text.replaceAll('\n', '<br/>')
        },
        sectionStyle() {
            return {
                textAlign: this.resolvedTextAlign
            }
        },
        textIsNotEmpty(text) {
            const temp = document.createElement('div')
            temp.innerHTML = text
            return temp.textContent.trim().length > 0
        },
        defaultTitleStyle() {
            return this.section.type === SectionTypesEnum.MAIN_HEADER ? 'h1' : 'default--h2'
        },
        defaultSubtitleStyle() {
            return this.section.type === SectionTypesEnum.MAIN_HEADER ? 'h2' : 'default--h4'
        }
    }
}
</script>